import { Link } from 'react-router-dom';

const comparisonData = [
  { methode: 'Normale Suche', geschwindigkeit: 'Mittel', uebersicht: 'Niedrig', anfaenger: 'Mittel' },
  { methode: 'Spreadsheet', geschwindigkeit: 'Sehr schnell', uebersicht: 'Sehr hoch', anfaenger: 'Sehr gut' },
  { methode: 'Zufällige Links', geschwindigkeit: 'Langsam', uebersicht: 'Schlecht', anfaenger: 'Niedrig' },
];

const steps = [
  { icon: 'ri-search-eye-line', title: 'Produkt entdecken', desc: 'Stöbere durch kuratierte Kategorien und finde inspirierende Produkte, die zu deinem Stil passen.' },
  { icon: 'ri-scales-3-line', title: 'Preis vergleichen', desc: 'Vergleiche Angebote verschiedener Verkäufer und finde das beste Preis-Leistungs-Verhältnis.' },
  { icon: 'ri-image-line', title: 'QC Fotos prüfen', desc: 'Überprüfe die tatsächliche Produktqualität anhand von echten QC-Fotos aus dem Lager.' },
  { icon: 'ri-shield-check-line', title: 'Sicher bestellen', desc: 'Bestelle mit den offiziellen Zahlungsmethoden und genieße einen geschützten Einkaufsprozess.' },
];

const securityItems = [
  'Keine Passwörter teilen',
  'Nur sichere Zahlungsmethoden verwenden',
  'Verkäufer prüfen',
  'QC Fotos kontrollieren',
  'Versandoptionen vergleichen',
  'Datenschutz beachten',
];

export default function ContentSections() {
  return (
    <>
      <section id="was-ist" className="w-full py-16 md:py-20 px-6 md:px-10 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase bg-secondary-100 text-secondary-800 rounded-full">
              Grundlagen
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              Was ist ein OOPBuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-3xl mx-auto">
              Ein OOPBuy Spreadsheet ist eine strukturierte Tabelle, die Produktlinks, Kategorien, Qualitätsbewertungen und Preisinformationen bündelt – kuratiert von erfahrenen Nutzern für schnelleres und sichereres Einkaufen.
            </p>
          </div>

          <div className="overflow-x-auto rounded-lg border border-background-200/70">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-secondary-100">
                  <th className="px-5 py-3.5 text-sm font-semibold text-foreground-800">Methode</th>
                  <th className="px-5 py-3.5 text-sm font-semibold text-foreground-800">Geschwindigkeit</th>
                  <th className="px-5 py-3.5 text-sm font-semibold text-foreground-800">Übersicht</th>
                  <th className="px-5 py-3.5 text-sm font-semibold text-foreground-800">Anfängerfreundlich</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, i) => (
                  <tr key={i} className={`border-b border-background-200/50 ${row.methode === 'Spreadsheet' ? 'bg-primary-50/60' : 'bg-background-50'}`}>
                    <td className="px-5 py-3.5 text-sm font-medium text-foreground-800">
                      {row.methode === 'Spreadsheet' && (
                        <span className="inline-block w-2 h-2 rounded-full bg-primary-500 mr-2"></span>
                      )}
                      {row.methode}
                    </td>
                    <td className="px-5 py-3.5 text-sm text-foreground-600">{row.geschwindigkeit}</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-600">{row.uebersicht}</td>
                    <td className="px-5 py-3.5 text-sm text-foreground-600">{row.anfaenger}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="w-full py-16 md:py-20 px-6 md:px-10 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase bg-accent-100 text-accent-800 rounded-full">
              Vorteile
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              Warum immer mehr Nutzer OOPBuy Spreadsheet verwenden
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {steps.map((step, i) => (
              <div key={i} className="relative group">
                <div className="flex flex-col items-center text-center p-6 md:p-8 bg-background-100 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-200">
                  <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200 mb-5">
                    <i className={`${step.icon} text-2xl`}></i>
                  </span>
                  <h4 className="font-heading text-lg font-bold text-foreground-900 mb-2">{step.title}</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <span className="w-6 h-6 flex items-center justify-center text-primary-400">
                      <i className="ri-arrow-right-s-line text-xl"></i>
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="sicherheit" className="w-full py-16 md:py-20 px-6 md:px-10 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase bg-secondary-100 text-secondary-800 rounded-full">
                Sicherheit
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                Ist OOPBuy sicher? – So schützt du dich
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
                Mit den richtigen Vorsichtsmaßnahmen und einem guten OOPBuy Spreadsheet als Leitfaden kannst du sicher und selbstbewusst einkaufen. Beachte diese grundlegenden Sicherheitsregeln.
              </p>
              <ul className="space-y-3">
                {securityItems.map((item, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className="text-sm text-foreground-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
              <div className="flex items-start gap-4">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className="ri-information-line text-xl"></i>
                </span>
                <div>
                  <h4 className="font-heading text-lg font-bold text-foreground-900 mb-2">Wichtiger Hinweis</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    Diese Website ist eine unabhängige Informationsplattform und nicht die offizielle OOPBuy Website. Wir bieten Orientierungshilfen und Empfehlungen, ersetzen aber nicht deine eigene Prüfung vor dem Kauf.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-16 md:py-20 px-6 md:px-10 bg-background-50">
        <div className="max-w-6xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase bg-primary-100 text-primary-700 rounded-full">
            Guide
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            OOPBuy Spreadsheet – Der komplette Guide
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto mb-8">
            Tauche tiefer ein mit unserem ausführlichen Leitfaden. Lerne alles über Kategorien, QC-Fotos, Preisvergleiche und Sicherheitsstrategien.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/oopbuy-spreadsheet-guide"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Vollständigen Guide lesen
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 text-base font-semibold border-2 border-primary-200 text-primary-700 rounded-md hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}